import { DATA_STATE_INVALID } from '../constants';
import { getHeight as getGlobalHeight, getMaxHeight as getGlobalMaxHeight, getMinHeight as getGlobalMinHeight, getWidth as getGlobalWidth, getMinWidth as getGlobalMinWidth, } from './sizes.global';
export function getHeight(transformer) {
    const globalHeight = getGlobalHeight(transformer);
    return Object.freeze({
        paginationItem: { value: globalHeight.m },
        logo: {
            m: { value: globalHeight.xl },
            l: { value: globalHeight.twoXl },
            xl: { value: globalHeight.threeXl },
            xxl: { value: globalHeight.fourXl },
        },
        icon: {
            s: { value: globalHeight.l },
            m: { value: globalHeight.xl },
            l: { value: globalHeight.twoXl },
            xl: { value: globalHeight.threeXl },
            xxl: { value: globalHeight.fourXl },
        },
        image: {
            s: { value: globalHeight.xl },
            m: { value: globalHeight.twoXl },
        },
        spinnerLoader: {
            s: { value: globalHeight.l },
            m: { value: globalHeight.xl },
            l: { value: globalHeight.threeXl },
        },
        circle: {
            xs: { value: globalHeight.six },
            s: { value: globalHeight.xl },
            m: { value: globalHeight.twoXl },
        },
        form: {
            checkbox: {
                box: {
                    default: { value: globalHeight.twoXl },
                    s: { value: globalHeight.xl },
                },
            },
            radioButton: {
                default: { value: globalHeight.twoXl },
                s: { value: globalHeight.xl },
            },
            switch: {
                container: { value: globalHeight.twoXl },
                knob: { value: globalHeight.thirty },
            },
            input: {
                default: { value: globalHeight.fourtySix },
                dataStates: {
                    [DATA_STATE_INVALID]: { value: globalHeight.fourtyFour },
                },
            },
            characterInput: {
                default: { value: globalHeight.fourXl },
            },
            textarea: {
                default: { value: globalHeight.auto },
            },
            accountSelect: {
                default: { value: globalHeight.fourXl },
            },
        },
        bottomSheetSlideButton: { value: globalHeight.m },
        progressIndicatorTrack: { value: globalHeight.m },
        iconButton: { value: globalHeight.threeXl },
        button: {
            s: { value: globalHeight.twoXl },
            m: { value: globalHeight.threeXl },
            l: { value: globalHeight.threeXl },
        },
        carouselContainer: { value: globalHeight.hundredTwenty },
        datepicker: { value: globalHeight.threeHundred },
    });
}
export function getMaxHeight(transformer) {
    const globalMaxHeight = getGlobalMaxHeight(transformer);
    return Object.freeze({
        bottomSheetContainer: { value: globalMaxHeight.sixtyPercent },
    });
}
export function getMinHeight(transformer) {
    const globalMinHeight = getGlobalMinHeight(transformer);
    return Object.freeze({
        attentionBlockContainer: { value: globalMinHeight.m },
        bottomSheetContainer: { value: globalMinHeight.xl },
        pageHeader: { value: globalMinHeight.fourXl },
    });
}
export function getWidth(transformer) {
    const globalWidth = getGlobalWidth(transformer);
    return Object.freeze({
        paginationItem: { value: globalWidth.m },
        carouselItem: { value: globalWidth.eightyPercent },
        icon: {
            s: { value: globalWidth.l },
            m: { value: globalWidth.xl },
            l: { value: globalWidth.twoXl },
            xl: { value: globalWidth.threeXl },
            xxl: { value: globalWidth.fourXl },
        },
        image: {
            s: { value: globalWidth.xl },
            m: { value: globalWidth.twoXl },
        },
        spinnerLoader: {
            s: { value: globalWidth.l },
            m: { value: globalWidth.xl },
            l: { value: globalWidth.threeXl },
        },
        circle: {
            xs: { value: globalWidth.six },
            s: { value: globalWidth.xl },
            m: { value: globalWidth.twoXl },
        },
        form: {
            checkbox: {
                box: {
                    default: { value: globalWidth.twoXl },
                    s: { value: globalWidth.xl },
                },
            },
            radioButton: {
                default: { value: globalWidth.twoXl },
                s: { value: globalWidth.xl },
            },
            switch: {
                container: { value: globalWidth.fiftySix },
                knob: { value: globalWidth.thirty },
            },
            characterInput: {
                default: { value: globalWidth.threeXl },
            },
        },
        attentionBlockBar: { value: globalWidth.s },
        bottomSheetSlideButton: { value: globalWidth.fourtyFour },
        progressIndicator: {
            indicatorsDivider: { value: globalWidth.s },
        },
        iconButton: { value: globalWidth.threeXl },
        datepicker: { value: globalWidth.threeHundred },
    });
}
export function getMinWidth(transformer) {
    const globalMinWidth = getGlobalMinWidth(transformer);
    return Object.freeze({
        progressIndicator: {
            indicator: { value: globalMinWidth.twoPercent },
        },
    });
}
